import IcomoonReact from 'icomoon-react';
import { css } from '@emotion/react';
import iconSet from './selection.json';

interface IconProps {
  color?: string;
  size?: string | number;
  icon: string;
  className?: string;
}

export const Icon = ({ color, size = '100%', icon, className }: IconProps): JSX.Element => {
  return (
    <IcomoonReact
      css={css`
        min-width: ${size}px;
        min-height: ${size}px;
        cursor: inherit;
      `}
      className={className}
      iconSet={iconSet}
      color={color}
      size={size}
      icon={icon}
    />
  );
};
